import PT from "prop-types";

import STATE_LIST from "../../../../static-data/state-list";

export const MORTGAGEE_TYPE_TO_TITLE = {
  primary: "Primary",
  secondary: "Secondary"
};

export const ADDRESS_SHAPE = {
  AddressLine1: PT.string,
  AddressLine2: PT.string,
  AddressCity: PT.string,
  AddressState: PT.string,
  AddressZip: PT.string
};

export const MORTGAGEE_SHAPE = {
  ...ADDRESS_SHAPE,
  LoanNumber: PT.string,
  Clauses: PT.string,
  Mortgagee: PT.string,
  ChangeType: PT.string
};

export const INPUT_SOURCES = {
  MORTGAGEE_DB: "MORTGAGEE_DB",
  MANUAL_INPUT: "MANUAL_INPUT",
  NOT_APPLICABLE: "NOT_APPLICABLE"
};

export const STEPS = {
  MORTGAGEE_LIST: "MORTGAGEE_LIST",
  ENTER_MORTGAGEE: "ENTER_MORTGAGEE",
  EMAIL_CONFIRMATION: "EMAIL_CONFIRMATION",
  SEND_EMAIL_CONFIRMATION: "SEND_EMAIL_CONFIRMATION",
  REVIEW_CHANGES: "REVIEW_CHANGES",
  MORTGAGEE_SEARCH: "MORTGAGEE_SEARCH"
};

export const INFO_FIELDS = {
  MORTGAGEE_NAME: {
    id: "Mortgagee",
    label: "Mortgagee name",
    type: "text",
    validation: [{ type: "required", message: "Mortgagee name is required." }]
  },
  CLAUSES: {
    id: "Clauses",
    label: "Clause",
    componentClass: "select",
    placeholder: "Select one",
    options: [
      { label: "None", value: "None" },
      { label: "ISAOA", value: "ISAOA" },
      { label: "ISAOA/ATIMA", value: "ISAOA/ATIMA" }
    ],
    validation: [{ type: "required" }]
  },
  ADDRESS_LINE_1: {
    id: "AddressLine1",
    label: "Address 1",
    type: "text",
    validation: [{ type: "required", message: "Address is required." }]
  },
  ADDRESS_LINE_2: {
    id: "AddressLine2",
    label: "Address 2",
    type: "text",
    validation: []
  },
  CITY: {
    id: "AddressCity",
    label: "City",
    type: "text",
    validation: [{ type: "required", message: "City is required." }]
  },
  STATE: {
    id: "AddressState",
    label: "State",
    componentClass: "select",
    options: [
      { label: "ST", value: "" },
      ...STATE_LIST.map(({ abbreviation }) => ({
        label: abbreviation,
        value: abbreviation
      }))
    ],
    validation: [{ type: "required", message: "State is required." }]
  },
  ZIP: {
    id: "AddressZip",
    label: "Zip",
    type: "text",
    validation: [
      { type: "required", message: "Zip is required." },
      { type: "zip", message: "Must be a valid ZIP Code." }
    ]
  },
  LOAN_NUMBER: {
    id: "LoanNumber",
    label: "Loan number",
    type: "text",
    validation: [
      { type: "required", message: "Loan number is required." },
      { type: "loanNumber", message: "Loan number must be valid." }
    ]
  }
};

export const REQUEST_FIELDS = {
  MORTGAGEE_NUMBER_1: {
    id: INFO_FIELDS.MORTGAGEE_NAME.id,
    name: "MortgageeNumber1",
    mortgageeType: "primary"
  },
  MORTGAGEE_1_ADDRESS_LINE_1: {
    id: INFO_FIELDS.ADDRESS_LINE_1.id,
    name: "Mortgagee1AddressLine1",
    mortgageeType: "primary"
  },
  MORTGAGEE_1_ADDRESS_LINE_2: {
    id: INFO_FIELDS.ADDRESS_LINE_2.id,
    name: "Mortgagee1AddressLine2",
    mortgageeType: "primary"
  },
  MORTGAGEE_1_CITY: {
    id: INFO_FIELDS.CITY.id,
    name: "Mortgagee1AddressCity",
    mortgageeType: "primary"
  },
  MORTGAGEE_1_STATE: {
    id: INFO_FIELDS.STATE.id,
    name: "Mortgagee1AddressState",
    mortgageeType: "primary"
  },
  MORTGAGEE_1_ZIP: {
    id: INFO_FIELDS.ZIP.id,
    name: "Mortgagee1AddressZip",
    mortgageeType: "primary"
  },
  LOAN_NUMBER_1: {
    id: INFO_FIELDS.LOAN_NUMBER.id,
    name: "LoanNumber1",
    mortgageeType: "primary"
  },
  MORTGAGEE_1_CHANGE_TYPE: {
    id: "ChangeType",
    name: "Mortgagee1ChangeType",
    mortgageeType: "primary"
  },
  MORTGAGEE_NUMBER_2: {
    id: INFO_FIELDS.MORTGAGEE_NAME.id,
    name: "MortgageeNumber2",
    mortgageeType: "secondary"
  },
  MORTGAGEE_2_ADDRESS_LINE_1: {
    id: INFO_FIELDS.ADDRESS_LINE_1.id,
    name: "Mortgagee2AddressLine1",
    mortgageeType: "secondary"
  },
  MORTGAGEE_2_ADDRESS_LINE_2: {
    id: INFO_FIELDS.ADDRESS_LINE_2.id,
    name: "Mortgagee2AddressLine2",
    mortgageeType: "secondary"
  },
  MORTGAGEE_2_CITY: {
    id: INFO_FIELDS.CITY.id,
    name: "Mortgagee2AddressCity",
    mortgageeType: "secondary"
  },
  MORTGAGEE_2_STATE: {
    id: INFO_FIELDS.STATE.id,
    name: "Mortgagee2AddressState",
    mortgageeType: "secondary"
  },
  MORTGAGEE_2_ZIP: {
    id: INFO_FIELDS.ZIP.id,
    name: "Mortgagee2AddressZip",
    mortgageeType: "secondary"
  },
  LOAN_NUMBER_2: {
    id: INFO_FIELDS.LOAN_NUMBER.id,
    name: "LoanNumber2",
    mortgageeType: "secondary"
  },
  MORTGAGEE_2_CHANGE_TYPE: {
    id: "ChangeType",
    name: "Mortgagee2ChangeType",
    mortgageeType: "secondary"
  }
};

export const CHANGE_TYPES = {
  NO_CHANGE: "1",
  ADD: "100",
  UPDATE: "101",
  DELETE: "200"
};

// TODO: is this different from other date formats?
export const DATE_FORMAT = "yyyy-MM-dd";

export const fieldList = [
  INFO_FIELDS.CLAUSES,
  INFO_FIELDS.LOAN_NUMBER,
  INFO_FIELDS.ADDRESS_LINE_1,
  INFO_FIELDS.ADDRESS_LINE_2,
  INFO_FIELDS.CITY,
  INFO_FIELDS.STATE,
  INFO_FIELDS.ZIP,
  INFO_FIELDS.MORTGAGEE_NAME
].map(f => f.id);

export const EMAIL_FORM_CONSTANTS = {
  TO: {
    id: "to",
    label: "To",
    placeholder: "Add multiple email addresses with a comma"
  },
  REPLYTO: { id: "replyTo", label: "From" },
  CC: { id: "cc", label: "Cc" },
  BCC: { id: "bcc", label: "Bcc" },
  SUBJECT: { id: "subject", label: "Subject" },
  MESSAGE: { id: "message", label: "Message", placeholder: "Add a message..." }
};
